function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "archive",
  d: "M22,6.386V8.7a.386.386,0,0,1-.386.386H5.386A.386.386,0,0,1,5,8.7V6.386A.386.386,0,0,1,5.386,6H21.614A.386.386,0,0,1,22,6.386Zm-5.409,6.182a.386.386,0,0,1-.386.386H10.8a.386.386,0,0,1-.386-.386V11.8a.386.386,0,0,1,.386-.386H16.2a.386.386,0,0,1,.386.386Zm4.25-2.7H6.159a.386.386,0,0,0-.386.386V20.3a1.161,1.161,0,0,0,1.159,1.159H20.068A1.161,1.161,0,0,0,21.227,20.3V10.25A.386.386,0,0,0,20.841,9.864Z",
  transform: "translate(-5 -6)",
  fill: "#323232"
});

function SvgIcHabitStatusArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 15.455,
    viewBox: "0 0 17 15.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHabitStatusArchive);
export default ForwardRef;